import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { getAxiosResponse, postAxiosFormDataResponse, downloadFile, postAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { openNewTab, utcDateTimeWithTimeZoneWithFormat } from "../../services/Util";
import { useDispatch, useSelector } from "react-redux";
import { updateSourceFiles } from "../../redux/reducers/SourceFilesSlice";
import CustomProgressBar from "../../components/global/CustomProgressBar";
import axios from "axios";
import { RotatingLines } from "react-loader-spinner";
import { Link,useLocation } from "react-router-dom";
import $ from "jquery";
import { click } from "@testing-library/user-event/dist/click";
import Constants from "../../Constants";
import TablePagination from '@mui/material/TablePagination';
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import { handleError } from "../../services/authApiRoutes/APImethods";
import DateFormat from "../DateFormat";

export default function OneTm() {
  const [globalOverlay, showGlobalOverlay] = useState(true);
  const scrollRef = useRef(null);
  const addRef = useRef(null);
  const paginationRef = useRef();
  const { t } = useTranslation();
  const {state} = useLocation();
  const translate = t;
  const [activeTab, setActiveSection] = useState("manage");
  const [active, setactive] = useState("");
  const [department, setDepartment] = useState([])
  const [tmDepartment, setTMDepartment] = useState([])
  const [customTMList, setCustomTMList] = useState([])
  const [tm, setTm] = useState({})
  const [size, setSize] = useState(15)
  const [customer, setCustomer] = useState({})
  const [depGroup, setDepGroup] = useState([])
  const [sourceLanguageTm, setSourceLanguageTm] = useState([])
  const [sourceLanguageTmData, setSourceLanguageTmData] = useState(null)
  const [url, setUrl] = useState(null)
  const [targetlanguageTm, setTargetLanguageTm] = useState([])
  const [targetlanguageTmData, setTargetLanguageTmData] = useState(null)
  const [departments, updatedDepartment] = useState([]);
  const [depId, setDepId] = useState(null);
  const [customTMId, setCustomTMId] = useState(null);
  const [modifiedData, setModifiedData] = useState({ label: "Last 60 days", value: "60" });
  const [tuValue, setBrowseTm] = useState([]);
  const [customerUser, setCustomerUser] = useState([])
  const [project, setProjectSearch] = useState([])
  const [containText, setContainText] = useState('')
  const [projectSearchData, setProjectSearchData] = useState(null)
  const [lastModifiedData, setLastModifiedData] = useState(null)
  const [translationData, setTranslationData] = useState(null)
  const [advanceFilterUrl, setAdvanceFilterUrl] = useState(null)
  const [permission, setPermission] = useState({});
  const [feature, setFeatures] = useState({})
  const [tuv, setValueData] = useState(null);
  const [indexPop, setIndex] = useState(null)
  const [lang, setLang] = useState("")
  const [tdData, setTdData] = useState({ index: "", currentLang: "" })
  const [collectionName, setCollectionName] = useState("")
  const [depObject, setDepObject] = useState(null)
  const [transaltionMemoryData, setTranslationMemoryData] = useState("")
  const [customTmName, setCustomTmName] = useState("")
  const [totalCount, setTotalCount] = useState(0);
  const [record, setRecord] = useState([1]);
  const [startPageSize, setStartPageSize] = useState(0)
  const [status, setStatus] = useState("")
  const [uploadStatus, setUploadStatus] = useState("")
  const [fileUploadRes, setFileUploadResponse] = useState("")
  const [modelStatus, setModelStatus] = useState(false)
  const [queryGroupedTUs, setQueryGroupedTUs] = useState(0)
  const [queryRawTUs, setQueryRawTUs] = useState(0)
  const [languageHeader, setLanguageHeader] = useState({ sourceLanguage: "", targetlanguage: "" })
  const [searchTargetLanguage, setSearchTragetLanguage] = useState(null)
  const [lasChunkStatus, setLasChunkStatus] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [page, setPage] = useState(0)
  const [rightModelStatus, setRightModelStatus] = useState(false)
  const [conditionalpopup, setconditionalpopup] = useState(false);
  const [targetLanguageStatus, setTargetLanguageStatus] = useState(false);
  const [createdVendorName,setCreatedVendorName]= useState("");
  const [modifiedVendorName,setModifiedVendorName]= useState("");
  const [isCustomTM,setIsCustomTM]= useState(false);
  const [customTMComboBox ,setCustomTMComboBox] = useState([]);
    /// upload
    const [selectedfile, setSelectedFile] = useState("");
    const [files, setFiles] = useState([]);
    const [documentVariant, setDocumentVariant] = useState();
    const [currentFileIndex, setCurrentFileIndex] = useState(null);
    const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
    const fileQueue = useRef([]);
    const [showError, setError] = useState(false);
    const chunkSize = Constants.CHUNK_SIZE;
 
    const params = new URLSearchParams(window.location.search);
    
    const [tableStatus,setTableStatus]=useState(false)
    const [customTM, setCustomTM] = useState();
    const departmentSelectRef = useRef(null);
    const projectSelectRef = useRef(null);
    const customTmSelectRef = useRef(null);

  const langTooltip = (index, lang) => {
    setactive(!active);
    setIndex(index);
    setLang(lang);
    setTimeout(() => {
      $('.DeleteTuvDataBtn').trigger('focus');
    }, 0);
  };


  useEffect(()=>{    
     if(params.size > 0){
      setActiveSection("searchedit");
      setTimeout(()=>{
        setDepId(params.get("depId"))
      },1000)
      setContainText(params.get("containingText"))
      setSourceLanguageTmData({label:"",value:params.get("srcLang")})
      setModifiedData({label:"",value:params.get("md")})      
     }
  },[])

  useEffect(()=>{
if(params.size > 0){
        if(departments?.length > 0){
          setDepId(+params.get("depId"))
        }
     }
  },[departments])


  useEffect(()=>{
    if(params.size > 0){
             if(params.get("trg") !==null){
            if(targetlanguageTm.length > 0){
              if(targetlanguageTm.filter(function (option) {
                return option.value === params.get("trg");
              })?.length > 0){
              setTargetLanguageTmData({label:"",value:params.get("trg")})
              }else{
                setTargetLanguageStatus(true)
              }
            }
          }
         }
      },[targetlanguageTm])
    
  
  const handlingLangTooltip = (index, event) => {
    if (event.key === Constants.ENTER || event.keyCode === 32) {
      event.preventDefault();
      langTooltip(index, "source")
    } else if (event.key === Constants.ESCAPE && active) {
      event.preventDefault();
      setactive(!active);
      $('.addFocus .circle').trigger('focus');
      $('.addFocus').removeClass('addFocus');
    } else if (event.key === Constants.TAB && !event.shiftKey &&
      $('.circle.active .inner-popover').find('button:last').is(':focus')) {
        setactive(!active);
        event.preventDefault();
        $(event.target).closest('.circle').trigger('focus');
        $('.addFocus').removeClass('addFocus');
    }
  };
  const handlingsetTranslationRendering = (index, event) => {
    if (event.key === Constants.ENTER || event.keyCode === 32) {
      event.preventDefault();
      setTranslationRendering("source", index)
    }
  };
  const cancelSourceEdit = () => {
    setTdData({ index: "", currentLang: "" })
  }

  $(document).on("click",'#cancelSourceBtn, #saveSourceBtn, #cancelTargetBtn, #saveTargetBtn', function() {
    $('.addFocus .circle').prev().trigger('focus');
    $('.addFocus').removeClass('addFocus');
  });
  const langTragetTooltip = (index, lang) => {
    setStatus(!status);
    setIndex(index)
    setLang(lang)
    setTimeout(() => {
      $('.DeleteTuvDataBtn').trigger('focus');
    }, 0);
  };
  const handlingLangTragetTooltip = (index, event) => {
    if (event.key === Constants.ENTER || event.keyCode === 32) {
      event.preventDefault();
      langTragetTooltip(index, "target")
    } else if (event.key === Constants.ESCAPE && status) {
      event.preventDefault();
      setStatus(!status);
      $('.addFocus .circle').trigger('focus');
      $('.addFocus').removeClass('addFocus');
    } else if (event.key === Constants.TAB && !event.shiftKey &&
      $('.circle.active .inner-popover').find('button:last').is(':focus')) {
      setStatus(!status);
      event.preventDefault();
      $(event.target).closest('.circle').trigger('focus');
      $('.addFocus').removeClass('addFocus');
    }
  };

  const perPage = 15;

  //API CALLS


  const getAvailableDepartment = () => {
    getAxiosResponse(APIUrls?.AVAILABLE_DEPARTMENTS).then(res => {
      if (res?.data?.data && res?.data?.data?.length > 0) {
        setDepartment(res?.data?.data)
        const result = res?.data?.data?.map(data => {
          return {
            label: data?.name,
            value: data?.id
          }
        })
        updatedDepartment(result)
      }
    }).catch(err => {
      handleError(err)
    })
  }
  const getTMDepartment = () => {
    getAxiosResponse(APIUrls?.TM_DEPARTMENT).then(res => {
      if (res?.data?.data && res?.data?.data?.length > 0) {
        setTMDepartment(res?.data?.data)
      }
    }).catch(err => {
      handleError(err)
    })
  }

  const getCustomTM = () =>{
    getAxiosResponse(APIUrls?.CUSTOM_TM_LIST).then(res => {
      if (res?.data?.data && res?.data?.data?.length > 0) {        
        setCustomTMList(res?.data?.data);
        let customTMWithDetailsList = res?.data?.data;
        getAxiosResponse(APIUrls.CUSTOM_TM).then((res)=>{ 
          let customTM = res.data;                    
          customTM.forEach(tm=>{              
              let filteredDetailedCustomTM = customTMWithDetailsList.filter(customTM=>customTM.userGroup.id === tm.id); 
              if(filteredDetailedCustomTM.length > 0){                  
                tm.createdDate = filteredDetailedCustomTM[0].createdDate;
                tm.creatorUser = filteredDetailedCustomTM[0].creatorUser;                
                tm.contentPath = filteredDetailedCustomTM[0].contentPath;                
              }              
          });           
          setCustomTM(customTM.filter((tm)=>tm.name!==""));
          let customTMComboBox = customTM.map(tm=>{  return {label :tm.name, value:tm.id} });                    
          setCustomTMComboBox(customTMComboBox);
        });
      }
    })
  }


  const getCustomer = () => {
    getAxiosResponse(APIUrls.GET_CUSTOMER_INFORMATION).then(res => {
      if (res?.data?.data) {
        setCustomer(res?.data?.data)
      }
    }).catch(err => {
      handleError(err)
    })
  }


  const getTM = () => {
    getAxiosResponse(APIUrls?.TM).then(res => {
      if (res?.data?.data) {
        setTm(res?.data?.data)
      }
    }).catch(err => {
      handleError(err)
    })
  }


  const getCustomerPermission = () => {
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then(res => {
      setPermission(res?.data?.data?.permissions)
      setFeatures(res?.data?.data?.features)
    }).catch(err => {
      handleError(err)
    })
  }

  const getSourceLanguageTm = () => {
    getAxiosResponse(APIUrls.TM_SOURCE_LANGUAGE).then(res => {
      if (res?.data?.data) {
        const result = res?.data?.data?.map(data => {
          return {
            label: data?.display,
            value: data?.languageCode,
            language: data?.language
          }
        })
        setSourceLanguageTm(result)
      }
    }).catch(err => {
      handleError(err)
    })
  }


  const getTargetLanguageTm = () => {    
    let dep = (depId !== null ? "?userGroupId=" + depId : "");    
    dep = (customTMId !== null ?  "?customTmId=" + customTMId : "");
    getAxiosResponse(APIUrls.TM_TARGET_LANGUAGE + dep).then(res => {
      if (res?.data?.data) {
        const result = res?.data?.data?.map(data => {
          return {
            label: data?.display,
            value: data?.languageCode,
            language: data?.language
          }
        })
        
        if(result && result.length>0){
          let data=result.filter(function (option) {
          return option.value === targetlanguageTmData?.value;
          });
          if(!data ||  data.length ===0){
            setTargetLanguageTmData(null)
          }
      }
      else{
        setTargetLanguageTmData(null)

      }

        setTargetLanguageTm(result)
      }
    }).catch(err => {
      handleError(err)
    })
  }


  const companyDownload = () => {
    showGlobalOverlay(true)
    downloadFile(APIUrls.DOWNLOAD_URL(tm?.contentPath), tm?.filename).then(res => {
      showGlobalOverlay(false)
    }).catch(err => {
      showGlobalOverlay(false)
      handleError(err)
    })
  }


  const projectSearch = (value) => {
    getAxiosResponse(APIUrls.PROJECT_NAME(value)).then(res => {
      if (res?.data?.data) {
        setProjectSearch(res?.data?.data)
      } else {
        setProjectSearch([])
      }
    }).catch(err => {
      handleError(err)
    })
  }


  const getCustomerUser = () => {
    getAxiosResponse(APIUrls.CUSTOMER_USER).then(res => {
      if (res?.data?.data) {
        const result = res?.data?.data?.map(data => {
          return {
            label: data?.firstName + " " + data?.lastName,
            value: data
          }
        })
        setCustomerUser(result)
      }
    }).catch(err => {
      handleError(err)
    })
  }


  const departmentTmDownload = (url, fileName) => {
    showGlobalOverlay(true)
    downloadFile(APIUrls.DOWNLOAD_URL(url), fileName).then(res => {
      showGlobalOverlay(false)
    }).catch(err => {
      showGlobalOverlay(false)
      handleError(err)
    })
  }

const customTmDownload = (fileName, tm) => {
    showGlobalOverlay(true)    
    downloadFile(APIUrls.CUSTOM_TM_DOWNLOAD(tm?.id), fileName+"_CUSTOM_TM.zip").then(res => {
      showGlobalOverlay(false)
    }).catch(err => {
      showGlobalOverlay(false)
      handleError(err)
    })
  }


  const departmentData = () => {
    showGlobalOverlay(true)
    let departmementsData = [];
    if ((department && department.length > 0) && (tmDepartment && tmDepartment.length > 0)) {
      department.forEach(dep => {
        tmDepartment.forEach(tmDep => {
          if (dep.id === tmDep?.userGroup.id) {
            departmementsData.push(tmDep)
          }
        })
        if (!departmementsData.find(el => el?.userGroup?.id === dep?.id)) {
          departmementsData.push({ userGroup: dep })
        }
      })
      showGlobalOverlay(false)      
      setDepGroup(departmementsData)
    } else {
      if (department && department.length > 0) {
        department.forEach(dep => {
          departmementsData.push({ userGroup: dep })
        })
        showGlobalOverlay(false)
      }
    }    
    setDepGroup(departmementsData)
    showGlobalOverlay(false)
  }

  const getPaginatedData = (currentPage) =>{
    showGlobalOverlay(true)
      let start = (currentPage === 1 ? queryRawTUs < 15 ? 0 : (1 * perPage) : currentPage * perPage);
      setStartPageSize(start)
      let urlD = url + (advanceFilterUrl !== null ? advanceFilterUrl : "");
      let finalUrl = urlD + `&start=${start}&serverId=${0}&colName=${collectionName}`
      getAxiosResponse(APIUrls.TM_BROWSE_SET + finalUrl).then(res => {
        if (res?.data) {
          setBrowseTm(res?.data?.uberTMX)
          showGlobalOverlay(false)

          if ($('#next-button').next('button').attr('disabled')==="disabled") {
            paginationRef.current = $('#prev-button').attr('id');
          } else if ($('#prev-button').prev().attr('disabled')==="disabled") {
            paginationRef.current = $('#next-button').attr('id');
          } else {
            paginationRef.current = document.activeElement.id;
          }
          if (paginationRef.current) {
            $('#'+ paginationRef.current).trigger('focus');
            paginationRef.current = '';
          }
        }
      }).catch(err => {
        handleError(err)
        showGlobalOverlay(false)
      })
  }




  const pagination = useRef();
  const showModel = (index, tuValueData) => {
    $(document.activeElement).closest('td').addClass('addFocus');
    setValueData(tuValueData)
    if (index === indexPop) {
      tuvDepartment(tuValueData)
      setconditionalpopup(true);
      document.body.classList.add("modal-open");
    }
    setTimeout(() => {
      $(".model-first-focus").trigger("focus");
      $(".model-first-focus").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          e.preventDefault();
          $("#uploadTm").trigger("focus");
        } else if (e.key === Constants.ESCAPE) {
          e.preventDefault();
          $('.addFocus .circle').trigger('focus');
          $('.addFocus').removeClass('addFocus');
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideModel();
          $('.focusAdd').trigger('focus');
          $('.inline-flex').removeClass('focusAdd');
        }
      });
    }, 500);
  };
  const hideModel = () => {
    setModelStatus(false)
    document.body.classList.remove("modal-open");
    $('.addFocus .circle').trigger('focus');
    $('.addFocus').removeClass('addFocus');
  };

  $(document).on("click",".lastBtn",function() {
    $(this).addClass('focusAdd');
 });
 $(document).on("click",".close",function() {
   $('.focusAdd').trigger('focus');
   $('.lastBtn').removeClass('focusAdd');
 });

  const createOneTm = (depId, isCustomTm, customTMName) => {  
    setCustomTmName("");       
    if(customTMName){
      setCustomTmName(customTMName);
    }    
    setIsCustomTM(isCustomTm); 
    addRef.current = document.activeElement.id;

    setModelStatus(true)
    setconditionalpopup(false);
    if (depId !== undefined) {
      setDepId(depId)
    }
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $(".first-focus").on("keydown", function (e) {
        if (e.key === Constants.TAB &&  e.shiftKey === false) {
          e.preventDefault();
          if(!$('#valid-upload').hasClass("disabled")){
            $("#valid-upload").trigger("focus");
          } else if($('#uploadTmAfte').length) {
            $("#uploadTmAfte").trigger("focus");
          } else {
            $("#uploadTm").trigger("focus");
          }
          $("#uploadTm").on("keydown", function (e) {
            if (e.key === Constants.TAB && e.shiftKey === true) {
              e.preventDefault();
                $(".first-focus").trigger("focus");
            }
            if (e.key === Constants.TAB && e.shiftKey === true) {
              e.preventDefault();
              if(!$('#valid-upload').hasClass("disabled")){
                $("#valid-upload").trigger("focus");
              } else if ($('#uploadTmAfte').length) {
                $("#uploadTmAfte").trigger("focus");
              }
            }
          });
          $("#valid-upload").on("keydown", function (e) {
            if (e.key === Constants.TAB &&  e.shiftKey === false) {
              e.preventDefault();
              $("#uploadTm").trigger("focus");
            }
          });
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
         hideModelOneTm(false);
       }
      });
    }, 500);


  };

  const hideModelOneTm = (fetchData) => {
    setModelStatus(false)
    setSelectedFile("");
    setFileUploadResponse("")
    setUploadStatus("")
    setFileUploadResponse("")
    setFiles([])
    document.body.classList.remove("modal-open");
    if(fetchData){
      getTMDepartment();
      getTM();

    }
    $('.focusAdd').trigger('focus');
    $('.lastBtn').removeClass('focusAdd');
  };
  const keydownhandling = (event) => {
    if (event.key === Constants.ENTER || event.keyCode === 32) {
      event.preventDefault();
      hideModelOneTm(true);
    }
    if (event.key === Constants.TAB &&  event.shiftKey === false) {
      event.preventDefault();
      $("#uploadTm").trigger("focus");
    }
  };

  const rightModel = () => {
    setRightModelStatus(true)
    document.body.classList.add("right-modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $("#oneTmCancel").on("keydown", function (e) {
        const ccwSaveBtn = $("#additionSaveBtn")[0];
        if (ccwSaveBtn.disabled && e.key == Constants.TAB && !e.shiftKey) {
          e.preventDefault();
          $(".first-focus").trigger("focus");
        }
      })
      $("#additionSaveBtn").on("keydown", function (e) {
        if (e.key === Constants.TAB && !e.shiftKey) {
          e.preventDefault();
          $(".first-focus").trigger("focus");
        }
      })
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideModel();
          $('.focusAdd').trigger('focus');
          $('.inline-flex').removeClass('focusAdd');
        }
      });
      
      $(".onetm-right-modal").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE && $(document.activeElement).attr('aria-expanded') !== 'true') {
          hideRightModel();
        }
      });
      $('.close.first-focus').on("keydown", function (e) {
        if (e.key === Constants.TAB && e.shiftKey) {
          e.preventDefault();
          if ($('#additionSaveBtn').prop('disabled')) {
            $("#oneTmCancel").trigger("focus");
          } else {
            $('#additionSaveBtn').trigger("focus");
          }
        }
      });
    }, 500);
  };
  const hideRightModel = () => {
    setRightModelStatus(false)
    document.body.classList.remove("right-modal-open");
    if ($('.rightpopup-conditional-model').length) {
      $('#AdditionalFilter').trigger('focus');
    }  
  };


  const ModifiedWithin = [
    { label: "Last 60 days", value: "60" },
    { label: "Last 180 days", value: "180" },
    { label: "This year", value: "-2" },
    { label: "This year and last year", value: "-3" },
    { label: "Since beginning", value: "-1" },
  ]

  const inTranslation = [
    { label: "Source", value: "source" },
    { label: "Translation", value: "target" }
  ]
  $(document).on("click", ".blankbg .btn", function () {
    $('.circle').trigger(click)
  })

    // USE EFFECT 
    useEffect(() => {
      getAvailableDepartment()
      getTMDepartment();
      getCustomTM();
      getTM();
      getCustomer();
      getSourceLanguageTm();
      getCustomerUser();
      getCustomerPermission();
      $(document).on("click keydown",'.circle',function(e) {
        if (e.type === "click" || e.key === Constants.ENTER || e.keyCode === 32) {
          $(this).parent('.w-285').toggleClass('addFocus');
        }
      });
      $('.lastdisable').trigger('focus');
    }, [])

    useEffect(()=>{
      if(state !== null && state!== undefined){
        setActiveSection("searchedit");
        rightModel()
        projectSearch(state.projectDetail.name)
        setProjectSearchData({value: state.projectDetail.id, label: state.projectDetail.name})
      }
    },[state]);
  

  useEffect(() => {
    departmentData()
  }, [tmDepartment, department])

  //Primary filters 
  useEffect(() => {
    let url = "?"

    if (sourceLanguageTmData !== null) {
      url = url + "src=" + sourceLanguageTmData?.value
    }
    if (targetlanguageTmData !== null) {
      url = url + "&trg=" + targetlanguageTmData?.value
    }

    if (modifiedData !== null) {
      url = url + "&dt=" + modifiedData?.value + "&size=" + size
    }
    setUrl(url)
  }, [sourceLanguageTmData, targetlanguageTmData, modifiedData])

  //Additional Filters
  useEffect(() => {
    let url = ""
    if (containText !== '' && containText !== null) {
      url = url + "&text=" + containText
    }
    if (projectSearchData !== null) {
      url = url + "&pId=" + projectSearchData?.value
    }
    if (lastModifiedData !== null) {
      url = url + "&cUser=" + lastModifiedData?.value?.userId
    }
    if(lastModifiedData == null && !containText) {
      setTranslationData(null)
    }
    if (translationData !== null) {
      url = url + "&ft=" + translationData?.value
    }
    if (depId !== null && depId !== undefined) {
      url = url + "&depId=" + depId
    }
    if(customTMId){
      url = url + "&customTMId=" + customTMId
    }    
    setAdvanceFilterUrl(url)
  }, [depId, customTMId ,containText, projectSearchData, lastModifiedData, translationData])

  useEffect(() => {
    getTargetLanguageTm()
  }, [depId, customTMId])



  useEffect(() => {
    if (currentFileIndex !== null) {
      setCurrentChunkIndex(0);
    }
  }, [currentFileIndex]);

  useEffect(() => {
    if (currentChunkIndex !== null) {
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);

  useEffect(()=>{
    getVendor(tuv?.source?.createdUserOrOrgId,true)
    getVendor(tuv?.source?.lastUpdatedUserOrOrgId,false)

  },[tuv])
  const clearValue = (e) => {
    e.target.value = null
  }


  const getVendor = (vendorId,createdUser) => {
    if(vendorId !==undefined) {
      getAxiosResponse(APIUrls.VENDOR_BY_ID(vendorId)).then(res => {
        if (res?.data && res?.data?.data?.resource) {
            if(createdUser){
              setCreatedVendorName(res?.data?.data?.resource?.name);
            }
            else{
              setModifiedVendorName(res?.data?.data?.resource?.name);
            }
        }else{
          if(createdUser){
            setCreatedVendorName(vendorId);
          }
          else{
            setModifiedVendorName(vendorId);
          }
        }
      }).catch(err => {
        handleError(err)
      })
    }
    

  }

  $('#search-btn,  #AdditionalFilter').on('blur', function (e) {
    $('#search-btn').removeAttr('aria-labelledBy');
    $('#AdditionalFilter').removeAttr('aria-labelledBy');
  });
  const getTMBrowse = (resetPage) => {
    setLanguageHeader({ sourceLanguage: sourceLanguageTmData?.label, targetlanguage: targetlanguageTmData?.label })
    showGlobalOverlay(true)
    let finalUrl = url + (advanceFilterUrl !== null ? advanceFilterUrl : "");    
    hideRightModel()
    setSearchTragetLanguage(targetlanguageTmData)
    if(resetPage){
      setBrowseTm([])
    }
    getAxiosResponse(APIUrls.TM_BROWSE + finalUrl).then(res => {
      if (res?.data?.data) {
        if ($('#search-btn').is(':focus')) {
          $('#search-btn').attr("aria-labelledby", "searchResults");
        } else if ($('#AdditionalFilter').is(':focus')) {
          $('#AdditionalFilter').attr("aria-labelledby", "searchResults");
        }
        setTotalCount(res?.data?.data?.body?.resultDescriptor?.tempLocator?.size)
        setCollectionName(res?.data?.data?.body?.resultDescriptor?.tempLocator?.collectionName)
        setRecord(res?.data?.data?.body?.uberTMX)
        setQueryGroupedTUs(res?.data?.data?.body?.resultDescriptor?.queryGroupedTUs)
        setQueryRawTUs(res?.data?.data?.body?.resultDescriptor?.tempLocator?.size)
        if(resetPage){
          setPage(0)
          setBrowseTm(res?.data?.data?.body?.uberTMX)
        }
        else{
          getPaginatedData(page);
        }
      }
      showGlobalOverlay(false)
    }).catch(err => {
      handleError(err)
      showGlobalOverlay(false)
    })
  }

  const userGroupData = (tm) => {
    if (tm?.creatorUser && tm?.creatorUser?.roleSet) {
      if (tm?.creatorUser?.roleSet?.customerType) {
        return tm?.creatorUser?.firstName + " " + tm?.creatorUser?.lastName
      } else {
        if (tm?.creatorUser?.roleSet?.vendorType) {
          return tm?.creatorOrganization?.name + "(Vendor)";
        }
      }
    }
  }


  const tuvDepartment = (data) => {
    let url = `serverId=0&colName=${collectionName}&lang=${sourceLanguageTmData?.value}&row=${data?.rownum}&text=${data.source.text}&_=${new Date().getTime()}`
    getAxiosResponse(APIUrls.TUV_DEPARTMENT + url).then(res => {
      if (res?.data) {
        setDepObject(res?.data[0])
      }
    }).catch(err => {
      handleError(err)
    })
  }

  const userGroupName = (tm) => {
    if (tm?.id) {
      return tm?.userGroup?.name + " " + "Department";
    } else {
      return tm?.userGroup?.name;
    }
  }

  const setSection = (depId) => {
    setActiveSection("searchedit")
    setDepId(depId);
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $(".first-focus").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          $(".first-focus").trigger("focus");
        }
      });
    }, 500);
  }

  const sourceIn = (event) => {
    setSourceLanguageTmData(event)
  }

  const translateIn = (event) => {
    setTargetLanguageTmData(event)
    setTargetLanguageStatus(false)
  }

  const modifiedWithinFun = (event) => {
    setModifiedData(event)
  }

  const setDepartmentData = (event) => {      
    if(event && customTmSelectRef.current.getValue()){
      customTmSelectRef.current.clearValue();
    }
    if(event!==null){
      setDepId(event ? event?.value : null)
    }
    else{
      setDepId(null)
    }
  }

  const setProjectSearchDataAndToggle = (event) => {
    if (event && customTmSelectRef.current.getValue()) {
      customTmSelectRef.current.clearValue();
    }
    setProjectSearchData(event)
  }

  const setCustomTmDropDownValue = (event) => {
    if(event && (departmentSelectRef.current.getValue() || projectSelectRef.current.getValue())) {
      departmentSelectRef.current.clearValue();
      projectSelectRef.current.clearValue();
    }
    if(event!==null){
      setCustomTMId(event ? event?.value : null)
    }
    else{      
      setCustomTMId(null)
    }
  }

  const filterValidation = () => {

    if (targetlanguageTmData !== null && sourceLanguageTmData !== null && modifiedData !== null && containText !== null) {
      return false;
    } else {
      return true;
    }
  }





  const dispatch = useDispatch();
  const sourceFiles = useSelector(
    (reduxStore) => reduxStore.source_files
  ).value;

  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;

  function fileSelection(e) {
    if (e.target) {
      setSelectedFile(e.target.files[0]);
      setFileUploadResponse("")
      setUploadStatus("")
      setFileUploadResponse("")
    }
  }

  function handleFileSelect(e) {
    if (files.length === 0) {
      postAxiosFormDataResponse(APIUrls.TM_EDITS_JSON, {
        name: "CUSTOMER_TM",
        docType: "CUSTOMER_TM",
        // document.id:

      }).then((res) => {
        setDocumentVariant(res?.data?.documentFileId);
        setFiles((files) => [...files, selectedfile]);
        
        setCurrentFileIndex(0);
        setSelectedFile("");
        setLasChunkStatus(true)
        dispatch(
          updateSourceFiles([
            ...sourceFiles,
            selectedfile.name.replaceAll(" ", "_"),
          ])
        );
      });
    } else {
      fileQueue.current.push(selectedfile);
      updateSourceFiles([
        ...sourceFiles,
        selectedfile.name.replaceAll(" ", "_"),
      ])
    }
  }


  function readAndUploadCurrentChunk() {
    const reader = new FileReader();
    const file = files[currentFileIndex];
    if (!file) {
      return;
    }
    const from = currentChunkIndex * chunkSize;
    const to = from + chunkSize;
    const blob = file.slice(from, to);
    reader.onload = (e) => uploadChunk(e);
    reader.readAsDataURL(blob);
  }

  const handleKeyEditflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#renameInput").trigger("focus");
      }
    }
  };

  function uploadChunk(readerEvent) {
    const file = files[currentFileIndex];
    const data = readerEvent.target.result;
    const params = new URLSearchParams();
    params.set("name", file.name);
    params.set("size", file.size);
    params.set("docFileId", documentVariant);
    params.set("ignoreValidations", false);
    params.set("currentChunkIndex", currentChunkIndex);
    params.set("totalChunks", Math.ceil(file.size / chunkSize));
    $('.progressReport').trigger('focus');
    if (depId !== null) {
      params.set("departmentId", depId);
    }
    if(customTmName){
      params.set("customTMName",customTmName);
    }
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    const url =
      `${process.env.REACT_APP_BACKEND_SERVER}${APIUrls.TM_EDITS}?` +
      params.toString();
    axios.post(url, data, { headers }).then((response) => {
    $("#files").trigger('focus');
    const file = files[currentFileIndex];
      const filesize = files[currentFileIndex].size;
      const chunks = Math.ceil(filesize / chunkSize) - 1;
      const isLastChunk = currentChunkIndex === chunks;
      if (isLastChunk) {
        getCustomTM();
        setLasChunkStatus(false)
        if (!response?.data?.staus) {
          setUploadStatus(response?.data?.detail)
          setTimeout(() => {
            $('#files').trigger('focus');
          }, 300);
        }
        if (response?.data?.detail === "") {
          setFileUploadResponse("Upload Successful")
          setTimeout(() => {
            $('#uploadTmAfte').trigger("focus");
          }, 300);
        }
        file.finalFilename = response.data.finalFilename;
        setCurrentChunkIndex(null);
        setFiles(files.filter((fileInfo) => fileInfo.name !== file.name));
        setCurrentFileIndex(null);
      } else {
        setCurrentChunkIndex(currentChunkIndex + 1);
      }
    });
  }



  const tuvTargetValues = (tuValueData) => {
    let text = "";
      if (tuValueData?.tuvs && tuValueData?.tuvs?.length > 0) {
        tuValueData?.tuvs.sort(function(a,b) {           
          return new Date(a.lastUpdatedDate).getTime() - new Date(b.lastUpdatedDate).getTime();
        });
        tuValueData?.tuvs.forEach(data => {
          if (data?.language === searchTargetLanguage?.value) {
            text = data?.text
          }
        })
      }
      return text;
    
  }

  const deleteTuvData = (data, language) => {
    showGlobalOverlay(true)
    let obj;
    if (language === "source") {
      obj = {
        serverId: 0, collectionName: collectionName,
        row: data.rownum, language: sourceLanguageTmData?.language,
        oldText: data?.source?.text, delete: true, groupId: null
      }
    } else {
      let actualTuv=data?.tuvs?.filter(obj=>obj.language === targetlanguageTmData?.value);

      obj = {
        serverId: 0, collectionName: collectionName,
        row: data.rownum, language: targetlanguageTmData?.language,
        oldText: actualTuv[0]?.text, delete: true, groupId: null
      }
    showGlobalOverlay(false)

    }
    postAxiosResponse(APIUrls.TM_BROWSE_SET, obj).then(res => {
      if(res && res.data && res.data.uberTMX!==null){
        const filteredValue=tuValue?.filter(obj=>{
          return obj!==data;
        })
        if(filteredValue && filteredValue.length>0){
          setBrowseTm(filteredValue)
          setQueryGroupedTUs(queryGroupedTUs-1)
          setQueryRawTUs(queryRawTUs-1)
        }
      } 
      showGlobalOverlay(false)
      $('.lastdisable').trigger('focus');
    }).catch(err => {
      handleError(err)
      showGlobalOverlay(false)
    })
  }

  const handlingDeleteTuvData = (tuValueData, event) => {
    if (event.key === Constants.ENTER || event.keyCode === 32) {
      deleteTuvData(tuValueData, "source");
    }
  }
  const handlingDetailsPopup = (event, index, tuValueData) => {
    if (event.key === Constants.ENTER || event.keyCode === 32) {
      showModel(index, tuValueData);
    } else if (event.key === Constants.TAB && !event.shiftKey) {
      if(active){
        setactive(false);
      } else if (status) {
        setStatus(false);
      }
      $('.addFocus').removeClass('addFocus');
    }
  }
  const editTuvData = (data, language) => {
    showGlobalOverlay(true)
    let obj;
    if (language === "source") {
      obj = {
        serverId: 0, collectionName: collectionName,
        row: data.rownum, language: sourceLanguageTmData?.language,
        oldText: data?.source?.text, newText: transaltionMemoryData===""?data?.source?.text:transaltionMemoryData
      }
    } else {
      let actualTuv=data?.tuvs?.filter(obj=>obj.language === targetlanguageTmData?.value);
      obj = {
        serverId: 0, collectionName: collectionName,
        row: data.rownum, language: targetlanguageTmData?.language,
        oldText: actualTuv[0]?.text, newText: transaltionMemoryData ===""?actualTuv[0]?.text:transaltionMemoryData
      }
    }
    postAxiosResponse(APIUrls.TM_BROWSE_SET, obj).then(res => {
      showGlobalOverlay(false)
      
      if(res && res.data && res.data?.uberTMX!==null){
        const filteredValue=tuValue?.map(obj=>{
          if(obj===data){
            if (language === "source") {
              obj.source.text=transaltionMemoryData===""?obj.source.text:transaltionMemoryData;
            }
            if(language === "target"){
              let actualTuv=obj.tuvs?.filter(obj=>obj.language === targetlanguageTmData?.value);

              if(obj.tuvs && obj.tuvs.length>0){
                actualTuv[0].text=transaltionMemoryData ===""?actualTuv[0]?.text:transaltionMemoryData;

              }
            }
          }
          return obj;
        })
        if(filteredValue && filteredValue.length>0){
          setBrowseTm(filteredValue)
        }
      }
      
    }).catch(err => {
      handleError(err)
      showGlobalOverlay(false)
    })
    setTdData({ index: "", currentLang: "" })
  }

  const setSearchAndEdit = () => {
    setActiveSection("searchedit");
    setBrowseTm([])
    setTargetLanguageStatus(false)
  }

  const setManageData = () => {
    setActiveSection("manage")
    setAdvanceFilterUrl(null)
    setDepId(null)
    setRecord([1])
    setBrowseTm([])
    setTargetLanguageTmData(null)
    setSourceLanguageTmData(null)
    setModifiedData({ label: "Last 60 days", value: "60" })
  }

  const setTranslationRendering = (lang, index) => {
    document.activeElement.parentElement.classList.add("addFocus");
    setTdData({ index: index, currentLang: sourceLanguageTmData.label })
    setLang(lang)
    setTimeout(() => {
      $('textarea').trigger("focus");
    }, 300);
  }

  const setTranslationTargetRendering = (lang, index) => {
    document.activeElement.parentElement.classList.add("addFocus");
    setTdData({ index: index, currentLang: targetlanguageTmData.label })
    setLang(lang)
    setTimeout(() => {
      $('textarea').trigger("focus");
    }, 300);
  }

  const handlingsetTranslationTargetRendering = (index, event) => {
    if (event.key === Constants.ENTER || event.keyCode === 32) {
      event.preventDefault();
      setTranslationTargetRendering("target", index);
    }
  }
  const tmDownload = () => {
    showGlobalOverlay(true)
    var digits = '0123456789';
    let token = '';
    for (let i = 0; i < 3; i++) {
      token += digits[Math.floor(Math.random() * 10)];
    }
    let urlD = url + (advanceFilterUrl !== null ? advanceFilterUrl : "");
    let finalUrl = urlD + `&start=${startPageSize === 0 ? queryGroupedTUs : startPageSize}&serverId=${0}&colName=${collectionName}&dtkn=${token}`
    downloadFile(APIUrls.TM_DOWN + finalUrl, tm?.filename).then(res => {
      showGlobalOverlay(false)
    }).catch(err => {
      showGlobalOverlay(false)
    })
  }


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getPaginatedData(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 15));
    setPage(0);
  };
  const crumbs = [
    {label:'OneTm', url:''},
  ];

  const handleRowClick = (tm) => {
    if (tm?.id) {
      setActiveSection("searchedit");
      $('#search-edit-btn').trigger('focus');
    }
  }

  $('.addFocus').on('keydown', (e) => {
    if (e.key === Constants.ESCAPE) {
      cancelSourceEdit();
      setTimeout(()=>{
        $('.addFocus p').trigger('focus');
        $('.addFocus').removeClass('addFocus');
      }, 300);
    }
  });

  const editPopover = (event, index, languageTmData) => {
    if (event.type === 'click' || event.key === Constants.ENTER || event.keyCode === 32) {
      setTdData({ index: index, currentLang: languageTmData?.label });
      $(document.activeElement).closest('td').addClass('addFocus');
      setTimeout(() => {
        $('textarea').trigger("focus");
      }, 300);
    }
  }
  


  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
           <Breadcrumb crumbs={ crumbs } />           
            <div className="onetm-page">
              <div className="oneTM-heading">
              <h3>{translate("one-tm.translation_memory")}</h3>
              <p>{translate("one-tm.manage_and_browse")}</p>
              </div>
              <div className="dashboard-top with-auto mar-bot20 flex-center">
                <div className="group-btn flex-center" role="tablist">
                  <button
                    className={activeTab === "manage" ? "active dashboard-btn" : "dashboard-btn"}
                    role="tab"
                    aria-label={activeTab === "manage" ? "Current tab, Manage" : "Manage"}
                    aria-selected={activeTab === "manage" ? "true" : "false"}
                    onClick={() => setManageData()}>
                    {translate("one-tm.manage")}
                  </button>
                  <button
                    id="search-edit-btn"
                    className={activeTab === "searchedit" ? "active dashboard-btn first-focus" : "dashboard-btn"}
                    role="tab"
                    aria-label={activeTab === "searchedit" ? "Current tab, Search & Edit" : "Search & Edit"}
                    aria-selected={activeTab === "searchedit" ? "true" : "false"}
                    onClick={() => setSearchAndEdit()}>
                    {translate("one-tm.search_&_edit")}
                  </button>                  
                </div>
              </div>
              <div className={activeTab === "manage" ? "show" : "hide"}>
                <h6 className="mar-bot6">{translate("one-tm.translation_memory")}</h6>
                <p className="f14-para">{translate("one-tm.trans")}
                  <Link  onClick={()=>openNewTab("https://cloudwords.zendesk.com/hc/en-us/articles/206359013-Importing-Your-Translation-Memory-to-Cloudwords")} ><u>{translate("one-tm.im_trans")}</u></Link>&nbsp;{translate("one-tm.and")} <Link  onClick={()=>openNewTab("https://cloudwords.zendesk.com/hc/en-us/articles/206359833-Translation-Memory-Management-and-Departments")} ><u>{translate("one-tm.div_by_dept")}.</u></Link> </p>
                <div className="white-bg">
                  <div className="table-responsive global-table">
                    <table className="sortable" aria-label="Translation Memory">
                      <tr>
                        <th aria-label="Translation Memory" scope="col" className="link-color">{translate("one-tm.translation_memory")}</th>
                        <th aria-label="Last Updated Date" scope="col" className="link-color">{translate("one-tm.last_updated_date")}</th>
                        <th aria-label="Last Updated By" scope="col" className="link-color">{translate("one-tm.last_updated_by")}</th>
                        <th aria-label="Actions" scope="col" className="left-text link-color">{translate("one-tm.actions")}</th>
                      </tr>
                      <tbody>
                        <tr>
                          {tm && tm?.id ? <>
                            <td onClick={() => handleRowClick(tm)}><Link>Company</Link></td>
                            <td>
                            <div className="relative text">
                              <span className="font-zero setFastpass">
                                <DateFormat date={tm?.createdDate} />
                              </span>
                              <span aria-hidden="true">
                                <DateFormat date={tm?.createdDate} />
                              </span>
                            </div>
                            </td>
                            <td>{userGroupData(tm)}</td>
                            <td className="left-text">
                              {permission?.PROJECT_CUD ?
                                <button onClick={() => {setActiveSection("searchedit"); $('#search-edit-btn').trigger('focus')}} className="inline-flex mr-15" aria-label="Edit">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z" fill="#1D4ED8" stroke="white" strokeWidth="0.3" />
                                  </svg>
                                </button> : ""}
                              <button onClick={companyDownload} className="inline-flex mr-15" aria-label="Download">
                                <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                  <path d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z" fill="#1D4ED8" />
                                </svg>
                              </button>
                              {permission?.PROJECT_CUD ?
                                <button onClick={() => createOneTm(tm?.userGroup?.id)} className="inline-flex lastBtn" aria-label="Add">
                                  <svg className="aaa-change-stroke" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <path d="M8.64062 1V15.72" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M1.28027 8.36011H16.0003" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button> : ""}
                            </td></> : <>
                            <td onClick={() => tm?.id ? setSection(tm?.userGroup?.id) : setActiveSection("manage")}>{"Company"}</td>
                            <td></td>
                            <td></td>
                            <td className="left-text flex-center">
                              {permission?.PROJECT_CUD ? <>

                              <button  className="inline-flex mr-15 display-hidden" aria-label="Edit">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z" fill="#1D4ED8" stroke="white" strokeWidth="0.3" />
                                  </svg>
                                </button> 
                              <button className="inline-flex mr-15 display-hidden" aria-label="Download">
                                <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                  <path d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z" fill="#1D4ED8" />
                                </svg>
                              </button>

                                <button onClick={() => createOneTm(tm?.userGroup?.id)} aria-label="Add" className="lastBtn">
                                  <svg className="aaa-change-stroke" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <path d="M8.64062 1V15.72" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M1.28027 8.36011H16.0003" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button></> : ""}
                            </td>
                          </>}

                        </tr>
                        {depGroup && depGroup.length > 0 && depGroup.map((tm, index) => (
                          <tr key={index}>
                            {tm && tm?.id ? <>
                              <td onClick={() => tm?.id ? setSection(tm?.userGroup?.id) : setActiveSection("manage")}><Link>{userGroupName(tm)}</Link></td>
                              <td >
                                <div className="relative text">
                                  <span className="font-zero setFastpass">
                                    <DateFormat date={tm?.createdDate} />
                                  </span>
                                  <span aria-hidden="true">
                                    <DateFormat date={tm?.createdDate} />
                                  </span>
                                </div>
                              </td>
                              <td>{userGroupData(tm)}</td>
                              <td className="left-text">
                                <div className="flex-center">
                                  {permission?.PROJECT_CUD ?
                                    <button onClick={() => {setActiveSection("searchedit"); $('#search-edit-btn').trigger('focus')}} className="inline-flex mr-15" aria-label="Edit">
                                      <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                        <path d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z" fill="#1D4ED8" stroke="white" strokeWidth="0.3" />
                                      </svg>
                                    </button> : ""}
                                  <button onClick={() => departmentTmDownload(tm?.contentPath, tm.filename)} className="inline-flex mr-15" aria-label="Download">
                                    <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                      <path d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z" fill="#1D4ED8" />
                                    </svg>
                                  </button>

                                  {permission?.PROJECT_CUD ?
                                    <button className="inline-flex lastBtn" onClick={() => createOneTm(tm?.userGroup?.id)} aria-label="Add">
                                      <svg className="aaa-change-stroke" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path d="M8.64062 1V15.72" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M1.28027 8.36011H16.0003" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                      </svg>
                                    </button> : ""}
                                </div>
                              </td></> : <>
                              <td onClick={() => tm?.id ? setSection(tm?.userGroup?.id) : setActiveSection("manage")}>{userGroupName(tm)}</td>
                              <td></td>
                              <td></td>
                              <td className="left-text flex-center">
                                {permission?.PROJECT_CUD ? <>
                                  <button  className="inline-flex mr-15 display-hidden" aria-label="Edit">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z" fill="#1D4ED8" stroke="white" strokeWidth="0.3" />
                                  </svg>
                                </button> 
                              <button className="inline-flex mr-15 display-hidden" aria-label="Download">
                                <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                  <path d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z" fill="#1D4ED8" />
                                </svg>
                              </button>                              
                                  <button onClick={() => createOneTm(tm?.userGroup?.id)} aria-label="Add" id={"add-" + index}>
                                    <svg className="aaa-change-stroke" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                      <path d="M8.64062 1V15.72" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                      <path d="M1.28027 8.36011H16.0003" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                  </button>                                  
                                  </> : ""}
                              </td>
                            </>}
                          </tr>
                        ))}
                      </tbody>
                    </table>     
                    <div>Custom Translation Memory</div>
                    <div>Custom TMs are not linked to any department but can be selected individually during the project creation process.</div>           
                    <table className="sortable" aria-label="Translation Memory">
                      <tr>
                        <th aria-label="Translation Memory" scope="col" className="link-color">{translate("one-tm.translation_memory")}</th>                        
                        <th aria-label="Last Updated Date" scope="col" className="link-color">{translate("one-tm.last_updated_date")}</th>
                        <th aria-label="Last Updated By" scope="col" className="link-color">{translate("one-tm.last_updated_by")}</th>
                        <th aria-label="Actions" scope="col" className="left-text link-color">{translate("one-tm.actions")}</th>
                      </tr>
                      <tbody>                        
                        {customTM && customTM.length > 0 && customTM.map((tm, index) => (
                          <tr key={index}>
                            {tm && tm?.id ? <>
                              <td onClick={() => tm?.id ? setSection(tm?.userGroup?.id) : setActiveSection("manage")}><Link>{tm.name}</Link></td>                              
                              <td >	
                                <div class="relative text">	
                                  <span class="font-zero setFastpass">
                                    <DateFormat date={tm?.createdDate} />
                                  </span>	
                                  <span aria-hidden="true">
                                    <DateFormat date={tm?.createdDate} />
                                  </span>	
                                </div>	
                              </td>	
                              <td>{userGroupData(tm)}</td>
                              <td className="left-text">
                                <div className="flex-center">
                                  {permission?.PROJECT_CUD ?
                                    <button onClick={() => {setActiveSection("searchedit"); $('#search-edit-btn').trigger('focus')}} className="inline-flex mr-15" aria-label="Edit">
                                      <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                        <path d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z" fill="#1D4ED8" stroke="white" strokeWidth="0.3" />
                                      </svg>
                                    </button> : ""}
                                  <button onClick={() => customTmDownload(tm?.name,tm)} className="inline-flex mr-15" aria-label="Download">
                                    <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                      <path d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z" fill="#1D4ED8" />
                                    </svg>
                                  </button>                                  
                                  {permission?.PROJECT_CUD ?
                                    <button className="inline-flex" onClick={() => createOneTm(undefined,false,tm.name)} aria-label="Add" id={"add-" + index}>
                                      <svg className="aaa-change-stroke" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path d="M8.64062 1V15.72" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M1.28027 8.36011H16.0003" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                      </svg>
                                    </button> : ""}
                                </div>
                              </td></> : <>
                              <td onClick={() => tm?.id ? setSection(tm?.userGroup?.id) : setActiveSection("manage")}>{userGroupName(tm)}</td>
                              <td></td>
                              <td></td>                              
                              <td className="left-text flex-center">
                                {permission?.PROJECT_CUD ? <>
                                  <button  className="inline-flex mr-15 display-hidden" aria-label="Edit">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                    <path d="M3.74274 13.7625H0.15V10.0356L9.27777 0.626194L9.27793 0.626026C9.57536 0.31846 9.96965 0.15 10.3888 0.15C10.8079 0.15 11.2022 0.318418 11.5006 0.626918L12.8685 2.04144C13.167 2.35011 13.3317 2.76025 13.3317 3.19829C13.3317 3.63629 13.167 4.0464 12.8686 4.35506C12.8685 4.35508 12.8685 4.35511 12.8685 4.35514L3.74274 13.7625ZM10.4966 1.67942L10.3889 1.56823L10.2811 1.67932L8.91064 3.09206L8.80944 3.19637L8.91051 3.30082L10.2784 4.71445L10.3861 4.82567L10.4939 4.71462L11.8652 3.30188L11.9665 3.19753L11.8654 3.09306L10.4966 1.67942ZM1.575 12.1287V12.2787H1.725H3.09379H3.15726L3.20145 12.2332L9.27259 5.97481L9.37375 5.87053L9.27275 5.76609L7.90483 4.35157L7.79717 4.24024L7.68934 4.3514L1.61734 10.6106L1.575 10.6543V10.7151V12.1287ZM0.15 15.8462H13.65V17.33H0.15V15.8462Z" fill="#1D4ED8" stroke="white" strokeWidth="0.3" />
                                  </svg>
                                </button> 
                              <button className="inline-flex mr-15 display-hidden" aria-label="Download">
                                <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                  <path d="M7.30849 15.6277L13.816 9.12027C13.9164 9.00294 13.9689 8.85201 13.963 8.69765C13.957 8.54329 13.893 8.39686 13.7838 8.28763C13.6746 8.1784 13.5281 8.11441 13.3738 8.10845C13.2194 8.10248 13.0685 8.15499 12.9512 8.25547L7.92183 13.2787V0.613333C7.92183 0.450667 7.85721 0.294664 7.74219 0.179641C7.62716 0.064619 7.47116 0 7.30849 0C7.14583 0 6.98982 0.064619 6.8748 0.179641C6.75978 0.294664 6.69516 0.450667 6.69516 0.613333V13.2787L1.67196 8.25547C1.61698 8.19126 1.54932 8.13912 1.47322 8.1023C1.39713 8.06549 1.31425 8.0448 1.22978 8.04154C1.14531 8.03828 1.06108 8.05251 0.982376 8.08334C0.90367 8.11418 0.832187 8.16095 0.772415 8.22072C0.712642 8.28049 0.665871 8.35198 0.635036 8.43068C0.604201 8.50939 0.589968 8.59362 0.59323 8.67809C0.596493 8.76256 0.617181 8.84544 0.653995 8.92153C0.690809 8.99762 0.742956 9.06528 0.80716 9.12027L7.30849 15.6277Z" fill="#1D4ED8" />
                                </svg>
                              </button>                              
                                  <button onClick={() => createOneTm(tm?.userGroup?.id)} aria-label="Add" id={"add-" + index} className="lastBtn">
                                    <svg className="aaa-change-stroke" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                      <path d="M8.64062 1V15.72" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                      <path d="M1.28027 8.36011H16.0003" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                  </button>                                  
                                  </> : ""}
                              </td>
                            </>}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button id="Create Custom TM" onClick={() => createOneTm(undefined,true)} className="btn">
                Create Custom TM
            </button>
                  </div>
                  
                </div>
              </div>
              <div className={activeTab === "searchedit" ? "show onetm-searchtop" : "hide"}>
              <p>Search Translation Memory</p>
               {targetLanguageStatus ?<p className="textDanger">The specified target language is not among the target languages in your Translation Memory.</p>:Constants.BLANK }
                <div className="flex ontm-button  ">
                  <div className="flex wrap-dropdown mb-0 ">
                    <div className="global-dropdown-block  flex-center">
                      <label aria-label="Source In">Source In</label>
                      <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        isClearable={true}
                        aria-label="Source In"
                        value={sourceLanguageTm.filter(function (option) {
                          return option.value === sourceLanguageTmData?.value;
                        })} onChange={e => sourceIn(e)} options={sourceLanguageTm} classNamePrefix='cw' className="global-dropdown-select file_upload" />
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label aria-label="Translation In">Translation In</label>
                      <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        isClearable={true}
                        aria-label="Translation In"
                        value={targetlanguageTm.filter(function (option) {
                          return option.value === targetlanguageTmData?.value;
                        })} onChange={(e) => translateIn(e)} options={targetlanguageTm} classNamePrefix='cw' className="global-dropdown-select file_upload" />
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label aria-label="Modified Within">Modified Within</label>
                      <Select
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        aria-label="Modified Within"
                        value={ModifiedWithin.filter(function (option) {
                          return option.value === modifiedData?.value;
                        })} onChange={e => modifiedWithinFun(e)} options={ModifiedWithin} classNamePrefix='cw' className="global-dropdown-select" />
                    </div>
                  </div>
                  <div className="flex-center flex-right pt">
                    <button id="search-btn" onClick={() => getTMBrowse(true)} disabled={filterValidation()} className="active dashboard-btn">Search</button>
                    <button className="dashboard-btn" onClick={rightModel} id="AdditionalFilter">
                      <span className="filter-icon">
                        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5627 4.00922H7.56233C7.32684 4.00922 7.125 3.64384 7.125 3.21755C7.125 2.79127 7.32684 2.42589 7.56233 2.42589H18.5627C18.7982 2.42589 19 2.79127 19 3.21755C19 3.64384 18.7982 4.00922 18.5627 4.00922Z" fill="#1D4ED8"></path><path d="M2.99075 3.649H0.607496C0.280383 3.649 0 3.36861 0 3.0415C0 2.71439 0.280383 2.43401 0.607496 2.43401H2.99075C3.31786 2.43401 3.59824 2.71439 3.59824 3.0415C3.59824 3.36861 3.36459 3.649 2.99075 3.649Z" fill="#1D4ED8"></path><path d="M5.37429 6.03238C3.73873 6.03238 2.38354 4.6772 2.38354 3.04164C2.38354 1.40607 3.73873 0.0508881 5.37429 0.0508881C7.00986 0.0508881 8.36504 1.40607 8.36504 3.04164C8.36504 4.6772 7.05659 6.03238 5.37429 6.03238ZM5.37429 1.26588C4.39295 1.26588 3.59854 2.0603 3.59854 3.04164C3.59854 4.02298 4.39295 4.81739 5.37429 4.81739C6.35563 4.81739 7.15005 4.02298 7.15005 3.04164C7.15005 2.0603 6.35563 1.26588 5.37429 1.26588Z" fill="#1D4ED8"></path><path d="M0.437329 9.9906L11.4377 9.9906C11.6732 9.9906 11.875 10.356 11.875 10.7823C11.875 11.2085 11.6732 11.5739 11.4377 11.5739L0.437329 11.5739C0.201844 11.5739 -3.19429e-08 11.2085 -6.92097e-08 10.7823C-1.06476e-07 10.356 0.201844 9.9906 0.437329 9.9906Z" fill="#1D4ED8"></path><path d="M16.0093 10.3508L18.3925 10.3508C18.7196 10.3508 19 10.6312 19 10.9583C19 11.2854 18.7196 11.5658 18.3925 11.5658L16.0093 11.5658C15.6821 11.5658 15.4018 11.2854 15.4018 10.9583C15.4018 10.6312 15.6354 10.3508 16.0093 10.3508Z" fill="#1D4ED8"></path><path d="M13.6257 7.96743C15.2613 7.96743 16.6165 9.32262 16.6165 10.9582C16.6165 12.5937 15.2613 13.9489 13.6257 13.9489C11.9901 13.9489 10.635 12.5937 10.635 10.9582C10.635 9.32262 11.9434 7.96743 13.6257 7.96743ZM13.6257 12.7339C14.607 12.7339 15.4015 11.9395 15.4015 10.9582C15.4015 9.97684 14.607 9.18242 13.6257 9.18242C12.6444 9.18242 11.8499 9.97684 11.85 10.9582C11.85 11.9395 12.6444 12.7339 13.6257 12.7339Z" fill="#1D4ED8"></path></svg>
                      </span> Additional Filters
                    </button>
                  </div>
                </div>
               
              </div>
              <div className={activeTab === "searchedit" ? "show " : "hide"}>
              {tuValue && tuValue.length > 0 ?
                  <div className="white-bg">
                    <div className="flex search-heading">
                      <span id="searchResults">Showing {queryGroupedTUs} {queryRawTUs > 0 ? "of " + queryRawTUs : ""} translation units</span>
                      <a tabIndex={0} onClick={tmDownload} onKeyDown={(e)=>{
                        if (e.key === Constants.ENTER) {
                          tmDownload();
                        }
                      }}><strong>
                        Download
                        <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
                          <path d="M5.02273 11L9.8897 6.41955C9.96485 6.33696 10.0041 6.23072 9.99966 6.12207C9.9952 6.01342 9.94734 5.91036 9.86565 5.83347C9.78395 5.75658 9.67444 5.71154 9.55899 5.70735C9.44354 5.70315 9.33066 5.74011 9.24291 5.81083L5.48144 9.34655V0.431711C5.48144 0.317214 5.43311 0.207407 5.34709 0.126445C5.26106 0.0454838 5.14439 0 5.02273 0C4.90107 0 4.78439 0.0454838 4.69837 0.126445C4.61234 0.207407 4.56401 0.317214 4.56401 0.431711V9.34655L0.80713 5.81083C0.766008 5.76564 0.715403 5.72894 0.658493 5.70302C0.601582 5.67711 0.539595 5.66255 0.476421 5.66025C0.413247 5.65796 0.35025 5.66797 0.291386 5.68968C0.232521 5.71138 0.179059 5.7443 0.134355 5.78638C0.0896507 5.82845 0.0546701 5.87876 0.0316083 5.93416C0.00854662 5.98956 -0.00209831 6.04885 0.000341825 6.1083C0.00278196 6.16776 0.0182545 6.2261 0.0457881 6.27966C0.0733217 6.33322 0.112322 6.38084 0.160341 6.41955L5.02273 11Z" fill="#1D4ED8" />
                        </svg>
                      </strong></a>
                    </div>
                    <div className="search-result-content">
                      <table aria-label="Translation">
                        <tr>
                          <th>{languageHeader?.sourceLanguage} Source</th>
                          <th>{languageHeader?.targetlanguage} Translation</th>
                        </tr>
                        {tuValue && tuValue.length > 0 && tuValue.map((tuValueData, index) => (
                          <tr key={index}>
                            <td>
                              <div className="flex justify-center w-285">

                                {tdData?.index === index && tdData.currentLang === sourceLanguageTmData?.label ? <>
                                  <div className="w-d100 mar-bot14">
                                    <textarea aria-label={tuValueData?.source?.text} onChange={(event) => setTranslationMemoryData(event?.target?.value)} className="textarea" defaultValue={tuValueData?.source?.text} />
                                  </div>
                                  <div className="flex btn-gap"><button id="saveSourceBtn" onClick={() => editTuvData(tuValueData, "source")} className="blue-btn active">Save</button>
                                    <button id="cancelSourceBtn" onClick={cancelSourceEdit} className="blue-btn ">Cancel</button></div></> : <p tabIndex="0" role="link" onClick={() => setTranslationRendering("source", index)} onKeyDown={(e) => handlingsetTranslationRendering(index, e)}>{tuValueData?.source?.text}</p>}
                                {index === tdData?.index && lang === "source" && tableStatus ? "" : <div tabIndex="0" className={`${(index === indexPop && lang === "source") && active ? 'circle active' : 'circle'}`} aria-expanded={active? "true" : "false"} onClick={() => langTooltip(index, "source")} onKeyDown={(e) => handlingLangTooltip(index, e)} role="button" aria-label="More options">
                                  <div className="dots">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                  </div>
                                  <div className="blankbg"></div>
                                  {indexPop === index && lang === "source" ?
                                    <div className="popover-body">
                                      <div className="inner-popover">
                                        <button className='DeleteTuvDataBtn' onClick={() => deleteTuvData(tuValueData, "source")} onKeyDown={(e) => handlingDeleteTuvData(tuValueData, e)} aria-label="Delete">Delete</button>
                                        <button onClick={(e) => editPopover(e, index, sourceLanguageTmData)} onKeyDown={(e) => editPopover(e, index, sourceLanguageTmData)} aria-label="Edit">Edit</button>
                                        <button aria-label="Details" onClick={() => showModel(index, tuValueData)} onKeyDown={(e) => handlingDetailsPopup(e, index, tuValueData)}>Details</button>
                                      </div>
                                    </div> : ""}
                                </div>}
                              </div>
                            </td>
                            <td>
                              <div className="flex justify-center w-285">
                                {tdData?.index === index && tdData.currentLang === targetlanguageTmData?.label ? <>
                                  <div className="w-d100 mar-bot14">
                                    <textarea aria-label={tuvTargetValues(tuValueData)} autofocus="true" onChange={(event) => setTranslationMemoryData(event?.target?.value)} className="textarea" rows="4" cols="70" defaultValue={tuvTargetValues(tuValueData)} />
                                  </div>

                                  <div className="flex btn-gap"><button id="saveTargetBtn" onClick={() => editTuvData(tuValueData, "target")} className="blue-btn active">Save</button>

                                 
                                    <button id="cancelTargetBtn" onClick={() => setTdData({ index: "", currentLang: "" })} className="blue-btn ">Cancel</button></div></> : <p tabindex="0" role="link" onClick={() => setTranslationTargetRendering("target", index)} onKeyDown={(e) => handlingsetTranslationTargetRendering(index, e)}>{tuvTargetValues(tuValueData)}</p>}
                                {index === tdData?.index && lang === "target"  && tableStatus? "" : <div tabIndex="0" className={(index === indexPop && lang === "target") && status ? 'circle active' : 'circle'} aria-expanded={status? "true" : "false"} onClick={() => langTragetTooltip(index, "target")} onKeyDown={(e) => handlingLangTragetTooltip(index, e)}  role="button" aria-label="More options">
                                  <div className="dots">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                  </div>
                                  <div className="blankbg"></div>
                                  {index === indexPop && lang === "target" ?
                                    <div className="popover-body">
                                      <div className="inner-popover">
                                        <button className="DeleteTuvDataBtn" onClick={() => deleteTuvData(tuValueData, "target")} onKeyDown={(e) => handlingDeleteTuvData(tuValueData, e)} aria-label="Delete">Delete</button>
                                        <button onClick={(e) => editPopover(e, index, targetlanguageTmData)} onKeyDown={(e) => editPopover(e, index, targetlanguageTmData)} aria-label="Edit">Edit</button>
                                        <button aria-label="Details" onClick={() => showModel(index, tuValueData)} onKeyDown={(e) => handlingDetailsPopup(e, index, tuValueData)}>Details</button>
                                      </div>
                                    </div> : ""}
                                </div>}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </table>
                      <div className="table-style table-pagination">
                        <TablePagination
                          component="div"
                          count={totalCount}
                          page={page}
                          onPageChange={handleChangePage}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          rowsPerPageOptions={[15]}
                          showFirstButton={true}
                          showLastButton={true}
                          nextIconButtonProps={{
                            disabled: page === Math.ceil(totalCount / 15) - 1,
                            id: "next-button"
                          }}
                          backIconButtonProps={{
                            disabled: page === 0,
                            id: "prev-button"
                          }}
                        />
                      </div>
                    </div>
                  </div> : ""
                }
                {record.length > 0 ? "" : <div className="align-center"><span>No matching translation found in your Translation Memory. </span></div>}
            </div>
            </div>
          </div>
        </section>
      </div>
      {conditionalpopup ?
        <div className="lightbox-panel" aria-labelledby="translation_Details" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="translation_Details">Translation Details</h5>
              <button className="close model-first-focus" aria-label="close" onClick={hideModel}>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
              </button>
            </div>
            <div className="lightbox-content padd-22">
              <ul className="translation-onetm-list">
                <li tabIndex="-1">
                  <strong>{sourceLanguageTmData?.label} Source</strong>
                  <span>{tuv?.source?.text}</span>
                </li>
                <li>
                  <strong>{targetlanguageTmData?.label} Translation</strong>
                  <span>{tuv?.tuvs[0]?.text}</span>
                </li>
                <li>
                  <strong>Created By</strong>
                  <div className="relative text">
                    <span className="font-zero setFastpass">
                    {createdVendorName} on  &nbsp;
                    {utcDateTimeWithTimeZoneWithFormat(tuv?.source?.createdDate, custBootstrapDataRedux?.user?.timeZone, Constants.DATE_FORMAT_LL_HH_MM_SS)}
                    </span>
                    <span aria-hidden="true">{createdVendorName} on  &nbsp;
                    {utcDateTimeWithTimeZoneWithFormat(tuv?.source?.createdDate, custBootstrapDataRedux?.user?.timeZone, Constants.DATE_FORMAT_MM_DD_YYYY_HH_MM_SS)}
                    </span>
                  </div>
                </li>
                <li>
                  <strong>Most Recent Activity</strong>
                  <div className="relative text">
                    <span className="font-zero setFastpass">
                      Last updated by {modifiedVendorName} on  &nbsp;
                      {utcDateTimeWithTimeZoneWithFormat(tuv?.source?.lastUpdatedDate, custBootstrapDataRedux?.user?.timeZone, Constants.DATE_FORMAT_LL_HH_MM_SS)}
                    </span>
                    <span aria-hidden="true">
                      Last updated by {modifiedVendorName} on  &nbsp;
                      {utcDateTimeWithTimeZoneWithFormat(tuv?.source?.lastUpdatedDate, custBootstrapDataRedux?.user?.timeZone, Constants.DATE_FORMAT_MM_DD_YYYY_HH_MM_SS)}
                    </span>
                  </div>
                </li>
                {depObject?.name ? <li>
                  <strong>Department</strong>
                  <span>{depObject.name}</span>
                </li> : ""}
              </ul>
            </div>
          </div>
        </div> : 
        <div className="lightbox-panel medium-panel" aria-labelledby="addNew_TM" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="addNew_TM">{translate("one-tm.add_tm")}</h5>              
              <button id="uploadTm" disabled={lasChunkStatus} className="close" aria-label="close popup" onClick={() => hideModelOneTm(false)}>
                <svg onKeyDown={handleKeyEditflow} xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
              </button>
            </div>
            <div className="lightbox-content padd-22">              
            { isCustomTM && 
              <><label>Custom TM Name :</label> <input id="customTmNAME" type='textbox' value={customTmName} onChange={(event) => setCustomTmName(event?.target?.value)}/></>
              }
              <div className="upload-file-container">
                <div className="upload-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                    <path d="M31.125 34C31.125 34 38.398 34 39.0857 34C42.9051 34 46 30.8778 46 27.0255C46 23.1733 42.9051 20.0502 39.0857 20.0502C39.0682 20.0502 39.0525 20.0528 39.035 20.0528C39.0884 19.6168 39.1251 19.1754 39.1251 18.7252C39.1251 12.8021 34.366 8 28.4939 8C23.9185 8 20.0309 10.921 18.5311 15.0098C17.58 14.0485 16.264 13.4526 14.8115 13.4526C11.9074 13.4526 9.55363 15.8272 9.55363 18.7561C9.55363 18.8311 9.56238 18.9035 9.565 18.9777C6.35813 19.8719 4 22.8281 4 26.3476C4 30.5741 7.39588 34 11.5863 34C12.3099 34 18.875 34 18.875 34" stroke="#96ACCC" strokeWidth="2.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path d="M21 28L25 23L29 28" stroke="#96ACCC" strokeWidth="2.5" strokeMiterlimit="10" strokeLinecap="round"></path>
                    <path d="M25 41V24" stroke="#96ACCC" strokeWidth="2.5" strokeMiterlimit="10" strokeLinecap="round"></path>
                  </svg>
                </div>
                <div className="upload-format flex-column">
                  <p>{translate("one-tm.tmx")} <br />
                    {translate("one-tm.upload")} <a tabIndex={0}>{translate("one-tm.tmx_files")}</a> {translate("one-tm.zip_file")}</p>
                </div>
                <div className="input-file-container">
                  <div className="input-file-container">
                    <div className="input-file">
                      <input
                        type="file"
                        id="files"
                        className="file_upload first-focus"
                        disabled={lasChunkStatus} 
                        onChange={(e) => fileSelection(e)}
                        onClick={(e) => clearValue(e)}
                        aria-labelledby="uploadError"
                      />
                      <label className="file-button " htmlFor="files">
                        {selectedfile === "" ? "Choose file" : "Replace file"}
                      </label>
                    </div>
                    <span className="textDanger" id="uploadError">{uploadStatus}</span>
                    <span className="success">{fileUploadRes}</span>
                    {fileUploadRes && fileUploadRes.length > 0 &&
                      <div>
                        <button id="uploadTmAfte" disabled={lasChunkStatus} className="btn mt-2" aria-label={fileUploadRes + " close"} onClick={() => hideModelOneTm(true)} onKeyDown={(e)=>keydownhandling(e)}>
                          Close
                        </button>
                      </div>
                    }
                    <div className="gb-upload-files files">
                      {files.map((file, fileIndex) => {
                        let progress = 0;
                        if (file.finalFilename) {
                          progress = 100;
                        } else {
                          const uploading = fileIndex === currentFileIndex;
                          const chunks = Math.ceil(file.size / chunkSize);
                          if (uploading) {
                            progress = Math.round((currentChunkIndex / chunks) * 100);

                          } else {
                            progress = 0;
                          }
                          if (chunks === 1) {
                            progress = 50;
                          }
                        }
                        return (
                          <div className="show-flex flex-center multiple-files">
                            <div className="icon-block">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                fill="none"
                              >
                                <path
                                  d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                                  fill="#EA6404"
                                ></path>
                              </svg>
                            </div>
                            <div className="right-progressbar">
                              <label>{file.name}</label>
                              <CustomProgressBar
                                completed={progress !== "" ? progress : 0}
                                labelLineHeight="1px"
                                labelSize="14px"
                                width="100%"
                                labelClassName="progressBarLabel"
                                borderRadius="30px"
                                labelAlignment="outside"
                                labelColor="rgba(0,0,0,0.87)"
                                height="6px"
                                className="campaign_progress"
                                bgColor="#06B878"
                                baseBgColor="#D1DEF0"
                                ariaValuetext={progress !== "" ? progress : 0}
                                aria-label=""
                                aria-valuenow={progress !== "" ? progress : 0}
                              />
                            </div>
                          </div>
                        );
                      })}

                      {fileQueue.current.map((file, fileIndex) => {
                        return (
                          <div className="show-flex flex-center multiple-files">
                            <div className="icon-block">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                fill="none"
                              >
                                <path
                                  d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                                  fill="#EA6404"
                                ></path>
                                <path
                                  d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                                  fill="#EA6404"
                                ></path>
                              </svg>
                            </div>
                            <div className="right-progressbar">
                              <label>{file.name}</label>
                              <CustomProgressBar
                                completed={0}
                                labelSize="14px"
                                labelLineHeight="1px"
                                width="100%"
                                labelClassName="progressBarLabel"
                                borderRadius="30px"
                                labelAlignment="outside"
                                labelColor="rgba(0,0,0,0.87)"
                                height="6px"
                                className="campaign_progress"
                                bgColor="#06B878"
                                baseBgColor="#D1DEF0"
                                ariaValuetext={0}
                                aria-label=""
                                aria-valuenow={0}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="upload-file-ext flex-center">
                      <div className="inline-flex">
                        <strong className={selectedfile ? "show-flex" : "hide"}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="18"
                            viewBox="0 0 16 18"
                            fill="none"
                          >
                            <path
                              d="M6.71373 3.85714V2.57143H5.42801V3.85714H6.71373ZM7.99944 5.14286V3.85714H6.71373V5.14286H7.99944ZM6.71373 6.42857V5.14286H5.42801V6.42857H6.71373ZM7.99944 7.71429V6.42857H6.71373V7.71429H7.99944ZM15.0307 3.81696C15.2182 4.00446 15.3789 4.25893 15.5128 4.58036C15.6468 4.90179 15.7137 5.19643 15.7137 5.46429V17.0357C15.7137 17.3036 15.62 17.5312 15.4325 17.7188C15.245 17.9062 15.0173 18 14.7494 18H1.24944C0.981585 18 0.753906 17.9062 0.566406 17.7188C0.378906 17.5312 0.285156 17.3036 0.285156 17.0357V0.964286C0.285156 0.696429 0.378906 0.46875 0.566406 0.28125C0.753906 0.09375 0.981585 0 1.24944 0H10.2494C10.5173 0 10.8119 0.0669643 11.1334 0.200893C11.4548 0.334821 11.7093 0.495536 11.8968 0.683036L15.0307 3.81696ZM10.5709 1.36607V5.14286H14.3477C14.2807 4.94866 14.207 4.81138 14.1267 4.73103L10.9827 1.58705C10.9023 1.5067 10.7651 1.43304 10.5709 1.36607ZM14.428 16.7143V6.42857H10.2494C9.98158 6.42857 9.75391 6.33482 9.56641 6.14732C9.37891 5.95982 9.28516 5.73214 9.28516 5.46429V1.28571H7.99944V2.57143H6.71373V1.28571H1.57087V16.7143H14.428ZM8.13002 9.4721L9.2048 12.9777C9.25837 13.1585 9.28516 13.3326 9.28516 13.5C9.28516 14.0558 9.04241 14.5162 8.55692 14.8811C8.07143 15.2461 7.45703 15.4286 6.71373 15.4286C5.97042 15.4286 5.35603 15.2461 4.87054 14.8811C4.38504 14.5162 4.1423 14.0558 4.1423 13.5C4.1423 13.3326 4.16908 13.1585 4.22266 12.9777C4.36328 12.5558 4.76507 11.2299 5.42801 9V7.71429H6.71373V9H7.50725C7.65458 9 7.78516 9.04353 7.899 9.13058C8.01283 9.21763 8.08984 9.33147 8.13002 9.4721ZM6.71373 14.1429C7.06864 14.1429 7.37165 14.0792 7.62277 13.952C7.87388 13.8248 7.99944 13.6741 7.99944 13.5C7.99944 13.3259 7.87388 13.1752 7.62277 13.048C7.37165 12.9208 7.06864 12.8571 6.71373 12.8571C6.35882 12.8571 6.0558 12.9208 5.80469 13.048C5.55357 13.1752 5.42801 13.3259 5.42801 13.5C5.42801 13.6741 5.55357 13.8248 5.80469 13.952C6.0558 14.0792 6.35882 14.1429 6.71373 14.1429Z"
                              fill="#157EFB"
                            ></path>
                          </svg>
                        </strong>
                        <span>{selectedfile?.name}</span>
                      </div>
                    </div>
                    <div
                      className={
                        "error upload-error" + (showError === true ? " show" : " hide")
                      }
                    >
                      Upload Failed: Our Apologies. One or more files in the zip is not
                      supported by OPAL-Marketing.
                    </div>
                    <button
                      id="valid-upload"
                      className="btn"
                      disabled={(!isCustomTM && selectedfile) || (isCustomTM && selectedfile &&  customTmName && customTmName.trim()!=="") ? false : true}
                      onClick={(e) => handleFileSelect(e)}
                    >
                      Validate &amp; Upload
                    </button>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      }
      <div className="overlay rightpopup-conditional"></div>
      {rightModelStatus ?
        <div className="right-modal onetm-right-modal rightpopup-conditional-model"  aria-labelledby="additional_Filters" aria-modal="true" role="dialog">
          <div className="modal-header flex">
            <div className="left flex-center">
              <h5 id="additional_Filters">Additional Filters</h5>
            </div>
            <button className="close flex-center first-focus" aria-label="close" onClick={hideRightModel}>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path>
                <path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path>
              </svg>
            </button>
          </div>
          <div className="modal-content project-filter-content">
            <div className="filter-selector">
              <div className="global-dropdown-block mar-bot20">
                <Select onChange={e => setDepartmentData(e)}
                  ref={departmentSelectRef}
                  classNamePrefix='cw' options={departments} placeholder={"Department"}
                  menuShouldScrollIntoView={false}
                  closeMenuOnSelect={true}
                  aria-label="department"
                  isClearable={true}
                  value={departments?.filter(function (option) {
                    return option.value === depId;
                  })} className="global-dropdown-select w-d100" />

              </div>              
              <div className="global-dropdown-block mar-bot20">
                <Select onChange={e => setCustomTmDropDownValue(e)}      
                  ref={customTmSelectRef}          
                  classNamePrefix='cw' options={customTMComboBox} placeholder={"Custom TM"}
                  menuShouldScrollIntoView={false}
                  closeMenuOnSelect={true}
                  aria-label="Custom TM"
                  isClearable={true}
                  value={customTMComboBox?.filter(function (option) {                    
                    return option.value === customTMId;
                  })}                   
                  className="global-dropdown-select w-d100" />

              </div>
              <div className="global-dropdown-block mar-bot20">
                <input value={containText}
                       onChange={event => setContainText(event?.target?.value)}
                       type="text"
                       placeholder="Contains text"
                       classNamePrefix='cw'
                       className="form-control-sm w-d100" />
              </div>
              <div className="global-dropdown-block mar-bot20">
                <Select onChange={e => setProjectSearchDataAndToggle(e)}
                  menuShouldScrollIntoView={false}
                  ref={projectSelectRef}
                  value={projectSearchData}
                  closeMenuOnSelect={true}
                  isClearable={true}
                  aria-label="project name"
                  options={project} onKeyDown={e => projectSearch(e.target.value)} placeholder="Project Name" classNamePrefix='cw' className="global-dropdown-select w-d100" />
              </div>
              <div className="global-dropdown-block mar-bot20">
                <Select onChange={e => setLastModifiedData(e)}
                  menuShouldScrollIntoView={false}
                  closeMenuOnSelect={true}
                  value={lastModifiedData}
                  isClearable={true}
                  aria-label="last modified by"
                  options={customerUser} placeholder={"Last modified by"} classNamePrefix='cw' className="global-dropdown-select w-d100" />
              </div>
              <div className="global-dropdown-block mar-bot20">
                <Select onChange={e => setTranslationData(e)}
                  menuShouldScrollIntoView={false}
                  isClearable={true}
                  isDisabled={lastModifiedData===null && !containText}
                  value={translationData}
                  closeMenuOnSelect={true}
                  aria-label="In"
                  options={inTranslation} classNamePrefix='cw' placeholder={"in"} className="global-dropdown-select w-d100" />
              </div>              

              <div className="button-group flex">
                <button role="button" id="oneTmCancel" className="btn default-btn first_focus" onClick={hideRightModel}>Cancel</button>
                <button id="additionSaveBtn" disabled={filterValidation()} onClick={() => getTMBrowse(true)} className="btn">Apply</button>
              </div>
            </div>            
          </div>          
        </div> : ""}        
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>        
      </div>      
    </div>
  );
}
